import Vue from 'vue'
import { Component,  } from 'vue-property-decorator'
import {  mapGetters } from 'vuex'
import * as types from '@survey/store/types'
import * as accountTypes from '@account/store/types'
import {  SurveyStatisticsExamples,SurveyDetailHeader, SurveyReadQuestion ,SurveyReadExamples} from '@survey/components'
import api from '@survey/api'
import StatisticsModalView from '@survey/views/ModalViews/SurveyStatisticsDetailModalView.vue'
import { IEDate, invalidateUrl, uGetIsInDate,uGetDateFormat } from '@appbase/util'
 
@Component({
    components: { 
        StatisticsModalView,
        SurveyStatisticsExamples,
        SurveyDetailHeader, 
        SurveyReadQuestion,
        SurveyReadExamples },
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
            current: accountTypes.CURRENT,
            surveyDetail: types.SURVEY_STATISTICS,
            menuPermission : types.SURVEY_MENU_PERMISSIONS,
        })
    }
})
export default class SurveyStatisticsView extends Vue {
    user!: account.User
    current!: account.TCurrent
    surveyDetail!: survey.SurveyDetailResponse
    menuPermission!: survey.MenuPermissions
    
    surveyStatistics : Array<survey.SurveyStatisticsItem> = []
    surveyStatisticsDetailLists : Array<survey.SurveyStatisticsDetailItem> = []
    participantCount : number = 0
    showModal : boolean = false
    isPopup : boolean = false   
    isSurveyAdmin: boolean = false;
    isSurveyOwner: boolean = false;

    async created() {
        debugger;
        this.isPopup = this.$route.path.toLowerCase().includes('popup')
        this.isSurveyAdmin = this.current.permissions.isSuperAdmin
            || this.current.permissions.isCompanyManager || this.current.permissions.isSurveyManager; //회사관리자 로 수정 2024.08.02|| this.current.permissions.isSurveyManager;
        this.isSurveyOwner = this.user.personCode === this.surveyDetail.surveyDetailInfo.createdId;

        this.setPage({            
            title: this.$t('설문조사_결과').toString()
        })
              
        if(this.surveyDetail.surveyDetailInfo == null || !this.checkPermission(this.surveyDetail.surveyDetailInfo)){
            await (window as any).alertAsync(this.$t('잘못된_접근입니다').toString())
            this.goBack()
            return             
        }
                                 
        this.initStatisticsData()
        this.initParticipantCount()     
    }

    checkPermission(detail: survey.SurveyDetailItem): boolean {
        if(detail.status >= 2) {
            if(this.isSurveyOwner || this.isSurveyAdmin) {
                return true;
            } else {
                const Start: Date = IEDate(uGetDateFormat('yyyy-MM-DD', IEDate(detail.resultStartDate)));
                const End: Date =  IEDate(detail.resultEndDate);   
                let inDate: boolean = uGetIsInDate(new Date(), Start, End);

                if(detail.isPublic && inDate) {
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }                    
    }

    initParticipantCount(){        
        this.participantCount = this.surveyDetail.surveyDetailInfo.completedUserCount    
    }

    initStatisticsData(){
        let surveyId = this.surveyDetail.surveyDetailInfo.surveyId as number

        api.survey.getSurveyStatisticsLists(surveyId)
        .then(result =>{
             
            
            this.surveyStatistics = result.surveyStatisticsLists.map(item =>{
                if(item.isMultipleChoice){
                    let question = this.surveyDetail.questions.filter(questionItem =>{
                        return questionItem.questionInfo.surveyQuestionId == item.surveyQuestionId
                    })
                    var example = question[0].examples.filter(exmpleItem =>{
                        return exmpleItem.surveyExampleId == parseInt(item.surveyAnswer)
                    })

                    return {
                        ...item,
                        exampleText : example[0].exampleText
                    }
                }else{ // 주관식
                    return {
                        ...item,
                        exampleText : ''
                    }
                }
               
            })
            //여기서 질문 텍스트를 추가해줘야 됨
        })
    }

    setStatisticsData(questionId : number){        
        return this.surveyStatistics.filter(item =>{
            return item.surveyQuestionId == questionId
        })
    }

    
    goBack() {
        if(this.isPopup){
            window.close()
        }else{
            this.$router.push({
                name: "SurveyList",
                query: {
                    MENUID: this.$route.query.MENUID
                }
            })
        }
    }

    
    popupModal(data : survey.SurveyStatisticsListDetailResponse){
        // alert('receive event')
        console.log(data)
        this.surveyStatisticsDetailLists = data.surveyStatisticsDetailLists
        this.showModal = true
    }

     
    closeModal(){
        // 디테일 값 초기화
        this.surveyStatisticsDetailLists = []
        this.showModal = false        
    }    

    onExportExcel(){        
        var ifrmExcel = this.$refs.refExcelFrame as HTMLIFrameElement;
        
        if(ifrmExcel) {
            ifrmExcel.src = invalidateUrl(`/cm/CommonSurvey/Survey/api/Statistics/exportToExcel/${this.surveyDetail.surveyDetailInfo.surveyId}`)
        }
    }
}
